import "./foundation/base.js";
import "./foundation/animation.js";
import "./foundation/scroll.js";
import "./foundation/typing.js";
import { initArchiveCaseSwiper } from "./foundation/slider.js";

import './object/m-splash';
import './object/l-footer';
import './object/l-hamburger';
import './object/l-header';
import './object/p-home-about';
import './object/l-contact-animation-text';
import './object/p-home-keyvisual';
import './object/c-title';
import './object/p-recruit-about-us.js';

import { initThreeJSBackground } from './object/l-background';
import initSidebarScrollSpy from './object/l-sidebar';
import { initCompanyPage } from './object/p-company';

// DOMが読み込まれたら各処理を実行
document.addEventListener('DOMContentLoaded', () => {
  // ページごとに必要な初期化処理を呼び出す
  if (document.getElementById('threejs-container')) {
    initThreeJSBackground();
  }

  if (document.querySelector('.p-company')) {
    initCompanyPage();
  }

  initSidebarScrollSpy();
});

/**
 * トップページのニュースを3件取得して表示する
 */
function handleTopPageNews() {
  const container = document.getElementById('js-news-list');
  if (!container) {
    return; // トップページでなければ何もしない
  }

  const kurocoListApiUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/3/news-list?cnt=3';

  fetch(kurocoListApiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const articles = data.list;
      if (!articles || articles.length === 0) {
        container.innerHTML = '<li>お知らせはありません。</li>';
        return;
      }

      const articlesHtml = articles.map(article => {
        const subject = article.subject ? article.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
        return `
        <li class="m-archive__item">
          <a href="/news/?id=${article.topics_id}" class="m-archive__link">
            <div class="m-archive__thumbnail">
              <img src="${article.image.url}" alt="${(article.image && article.image.desc) || article.subject}" loading="lazy" class="m-archive__img">
            </div>
            <div class="m-archive__content">
              <time class="m-archive__date" datetime="${article.ymd}">${article.ymd.replace(/-/g, '.')}</time>
              <p class="m-archive__title">${subject}</p>
            </div>
          </a>
        </li>
        `;
      }).join('');
      container.innerHTML = articlesHtml;
    })
    .catch(error => {
      console.error('Failed to load top page news:', error);
      container.innerHTML = '<li>お知らせの読み込みに失敗しました。</li>';
    });
}

/**
 * トップページのインタビューを3件取得して表示する
 */
function handleTopPageInterview() {
  const container = document.getElementById('js-interview-list');
  if (!container) {
    return;
  }

  const apiUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/7/interview-list?cnt=3';

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const items = data.list;
      if (!items || items.length === 0) {
        container.innerHTML = '<li>インタビューはありません。</li>';
        return;
      }

      const html = items.map(item => {
        const imageUrl = item.detail_top_image.url;
        // タグ: contents_type_nm を先頭に、続けて tag 配列を展開
        let tagsHtml = '';
        if (item.contents_type_nm) {
          tagsHtml += `<span class="m-archive__tag">#${item.contents_type_nm}</span>`;
        }
        if (item.tag && Array.isArray(item.tag)) {
          tagsHtml += item.tag.map(tag => `<span class="m-archive__tag">${tag}</span>`).join('');
        }
        // タイトル: <br> や <br> などの改行タグを削除して1行にする
        const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';

        return `
        <li class="m-archive__item">
          <a href="/recruit/interview/?id=${item.topics_id}" class="m-archive__link">
            <div class="m-archive__thumbnail">
              <img src="${imageUrl}" alt="${item.name || subject}" loading="lazy" class="m-archive__img">
            </div>
            <div class="m-archive__content">
              <div class="m-archive__tags">${tagsHtml}</div>
              <h3 class="m-archive__title">${subject}</h3>
              <p class="m-archive__name">${item.name || ''}</p>
              <p class="m-archive__text">${item.list_summary || ''}</p>
            </div>
          </a>
        </li>
      `}).join('');
      container.innerHTML = html;
    })
    .catch(error => {
      console.error('Failed to load top page interview:', error);
      container.innerHTML = '<li>インタビューの読み込みに失敗しました。</li>';
    });
}

/**
 * ニュース一覧ページのデータをAPIから取得して表示する
 */
function handleNewsListPage() {
  const container = document.getElementById('news-list-container');
  if (!container) {
    return;
  }
  // URLから 'pageID' クエリパラメータを取得
  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page') || '1'; // パラメータがなければ1ページ目とする

  // APIのベースURL
  const baseUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/3/news-list';
  // ページ番号を付与したAPIのURLを組み立てる
  const kurocoListApiUrl = `${baseUrl}?cnt=12&pageID=${page}`; // 常に12件取得し、Kuroco APIには pageID を渡す

  fetch(kurocoListApiUrl)
    .then(response => {
      // 404 Not Foundエラーの場合もJSONとして処理を試みる
      if (!response.ok && response.status !== 404) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // APIから "pageID is too big." というエラーが返ってきたかチェック
      if (data.errors && data.errors.some(e => e.code === 'not_found' && e.message.includes('pageID is too big'))) {
        // ニュース一覧のトップページにリダイレクト
        window.location.href = '/news/';
        return;
      }

      // Kurocoの一覧APIでは、データは `list` プロパティに入っています
      const articles = data.list || data.details; // listがなければdetailsを試す
      if (!articles || articles.length === 0) {
        const paginationContainer = document.getElementById('pagination-container');
        if (paginationContainer) paginationContainer.innerHTML = ''; // 記事がない場合はページネーションも消す
        container.innerHTML = '<p>記事が見つかりませんでした。</p>';
        return;
      }

      let articlesHtml = '';
      articles.forEach(article => {
        const subject = article.subject ? article.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
        articlesHtml += `
          <li class="m-archive__item">
            <a href="/news/?id=${article.topics_id}" class="m-archive__link">
              <div class="m-archive__thumbnail">
                <img src="${article.image.url}" alt="${(article.image.desc) || article.subject}" loading="lazy" class="m-archive__img">
              </div>
              <div class="m-archive__content">
                <time class="m-archive__date" datetime="${article.ymd}">${article.ymd.replace(/-/g, '.')}</time>
                <p class="m-archive__title">${subject}</p>
              </div>
            </a>
          </li>
        `;
      });
      container.innerHTML = articlesHtml;
      // APIから取得したページ情報を使ってページネーションを生成
      renderPagination(data.pageInfo || data.pager, page);
    })
    .catch(error => {
      container.innerHTML = '<p>記事一覧の読み込みに失敗しました。</p>';
    });
}

/**
 * ページネーションのHTMLを生成して表示する
 * @param {object} pager - APIから返されるpagerオブジェクト
 * @param {string} currentPage - 現在のページ番号
 */
function renderPagination(pager, currentPage) {
  const container = document.getElementById('pagination-container');
  // pagerが存在しない、または総ページ数が1以下の場合は何も表示しない
  const totalPages = pager.totalPageCnt || pager.last_page;
  if (!container || !pager || totalPages <= 1) {
    if (container) container.innerHTML = ''; // コンテナを空にする
    return;
  }
  const lastPage = totalPages;
  const current = parseInt(currentPage, 10);
  const template = document.getElementById('pagination-template');
  if (!template) return;
  const paginationElement = template.content.cloneNode(true);
  const prevLink = paginationElement.querySelector('.c-pagination__btn-prev');
  const nextLink = paginationElement.querySelector('.c-pagination__btn-next');
  const itemsList = paginationElement.querySelector('.c-pagination__items');
  const itemTemplate = paginationElement.querySelector('.c-pagination__item');

  itemsList.innerHTML = '';
  // 「前へ」のリンク
  if (current > 1) {
    prevLink.href = `/news/?page=${current - 1}`;
  } else {
    prevLink.remove(); // 1ページ目の場合は「前へ」を削除
  }
  // ページ番号のリンク
  for (let i = 1; i <= lastPage; i++) {
    const newItem = itemTemplate.cloneNode(true);
    const newLink = newItem.querySelector('.c-pagination__link');
    newLink.href = `/news/?page=${i}`;
    newLink.textContent = i;
    if (i === current) {
      newItem.classList.add('is-current');
    }
    itemsList.appendChild(newItem);
  }
  // 「次へ」のリンク
  if (current < lastPage) {
    nextLink.href = `/news/?page=${current + 1}`;
  } else {
    nextLink.remove(); // 最終ページの場合は「次へ」を削除
  }
  // 最終的に生成した要素をコンテナに挿入
  container.innerHTML = ''; // コンテナを一度空にする
  container.appendChild(paginationElement);
}

function handleNewsDetailPage() {
  const articleSection = document.getElementById('article-section');
  if (!articleSection) return;

  // URLから 'id' クエリパラメータを取得
  const urlParams = new URLSearchParams(window.location.search);
  const articleId = urlParams.get('id');

  // URLにidがない場合は、ここで処理を終了
  if (!articleId) return;

  // Kurocoの1件取得APIエンドポイント
  const baseUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/3/news-details/';
  const kurocoArticleApiUrl = `${baseUrl}${articleId}`;

  // APIからデータを取得
  fetch(kurocoArticleApiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // Kurocoの詳細APIでは、データは `details` プロパティに入っています
      const article = data.details;

      if (!article) {
        articleSection.innerHTML = '<p>記事が見つかりませんでした。</p>';
        return;
      }

      // タイトルの改行タグ処理
      const subject = article.subject ? article.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '<br>') : '';

      // ページタイトルを動的に更新
      document.title = subject.replace(/<br\s*\/?>/gi, '') + ' | イグニション・ポイント フォース株式会社';

      // パンくずリストを動的に生成
      const breadcrumbContainer = document.getElementById('news-detail-breadcrumb');
      if (breadcrumbContainer) {
        const breadcrumbs = [
          { name: 'HOME', href: '/' },
          { name: '最新情報', href: '/news/' },
          { name: subject.replace(/<br\s*\/?>/gi, ''), href: '' } // 現在のページ
        ];
        let breadcrumbHtml = '<div class="c-breadcrumb"><div class="l-container l-container--fluid"><ol class="c-breadcrumb__list">';
        breadcrumbs.forEach(crumb => {
          breadcrumbHtml += `<li class="c-breadcrumb__item">${crumb.href ? `<a href="${crumb.href}">${crumb.name}</a>` : `<span>${crumb.name}</span>`}</li>`;
        });
        breadcrumbHtml += '</ol></div></div>';
        breadcrumbContainer.innerHTML = breadcrumbHtml;
      }

      // 詳細ページのHTMLを生成
      let articleHtml = `
        <div class="l-container l-container--sm">
          <article class="m-article__content">
            <h1 class="m-article__h1">${subject}</h1>
            <time class="m-article__date" datetime="${article.ymd || ''}">${(article.ymd || '').replace(/-/g, '.')}</time>
            <div class="m-article__image-main">
              <img src="${article.image.url}" alt="${(article.image.desc) || article.subject}">
            </div>
            <div id="article-body-content"></div>
          </article>
          <div class="m-article__section m-article__section--return-button">
            <a href="/news" class="c-button">
              <span class="c-btn__text">一覧に戻る</span>
              <span class="c-button__icon">
                <img src="/assets/img/common/icon-button-arrow.svg" alt="">
              </span>
            </a>
          </div>
        </div>
      `;
      articleSection.innerHTML = articleHtml;

      // 記事本文のHTMLを処理して挿入
      const detailsContainer = document.getElementById('article-body-content');
      if (detailsContainer && article.body && article.body.length > 0) {
        // 1. 一時的なdiv要素をメモリ上に作成
        const tempDiv = document.createElement('div');
        // 2. APIから受け取ったHTML文字列をdivのinnerHTMLとして設定し、パスを修正
        const separator = '<hr class="m-article__hr"><div class="m-article__section m-article__section--divider"><hr class="m-article__divider"></div>';
        tempDiv.innerHTML = article.body.join(separator).replace(/\/dist\//g, '/');

        // --- ボタンの整形処理 ---
        // 1. pタグのアンラップ: ボタンのみを含むpタグがあれば、pタグを削除して中身のaタグだけにする
        tempDiv.querySelectorAll('p').forEach(p => {
          const child = p.firstElementChild;
          // pタグの子要素が1つだけで、それがaタグであり、かつボタン系のクラスを持っている場合
          if (p.children.length === 1 && child && child.tagName === 'A' &&
             (child.classList.contains('m-article__button') || child.classList.contains('m-article__small-link'))) {
            p.replaceWith(child);
          }
        });

        // 2. クラスの置換とアイコンの更新
        tempDiv.querySelectorAll('a.m-article__small-link').forEach(a => {
           a.classList.remove('m-article__small-link');
           a.classList.add('m-article__button');
           if (a.classList.contains('m-article__small-link--pdf')) {
             a.classList.remove('m-article__small-link--pdf');
             a.classList.add('m-article__button--filled-pdf');

             // PDFボタンの構造を整形: テキストとアイコンを並列にする（余計なラッパーや空白を削除）
             const img = a.querySelector('img');
             const textSpan = a.querySelector('.m-article__small-link-text');

             if (img && textSpan) {
               const newSpan = document.createElement('span');
               newSpan.innerHTML = textSpan.innerHTML;

               a.innerHTML = '';
               a.appendChild(newSpan);
               a.appendChild(img);
             }
           }
        });

        // アイコン画像のパス更新
        tempDiv.querySelectorAll('img').forEach(img => {
           if (img.src.includes('external-link-large.svg')) {
             img.src = '/assets/img/common/icon-arrow-up-right-from-square.svg';
           } else if (img.src.includes('pdf-small.svg')) {
             img.src = '/assets/img/common/icon-pdf.svg';
           }
        });

        // 3. 連続するボタンのグルーピング
        const allButtons = tempDiv.querySelectorAll('a.m-article__button');
        const processedButtons = new Set();

        allButtons.forEach(btn => {
           if (processedButtons.has(btn)) return;

           const parent = btn.parentNode;
           const wrapper = document.createElement('div');
           wrapper.className = 'm-article__section m-article__section--buttons';
           parent.insertBefore(wrapper, btn);

           let current = btn;
           while (current && current.tagName === 'A' && current.classList.contains('m-article__button')) {
             const next = current.nextElementSibling;
             wrapper.appendChild(current);
             processedButtons.add(current);
             current = next;
           }
        });

        // 4. 注釈のグルーピング
        const allNotes = tempDiv.querySelectorAll('p.m-article__note');
        const processedNotes = new Set();

        allNotes.forEach(note => {
           if (processedNotes.has(note)) return;

           const parent = note.parentNode;
           const wrapper = document.createElement('div');
           wrapper.className = 'm-article__section m-article__section--notes';
           parent.insertBefore(wrapper, note);

           let current = note;
           while (current && current.tagName === 'P' && current.classList.contains('m-article__note')) {
             const next = current.nextElementSibling;
             wrapper.appendChild(current);
             processedNotes.add(current);
             current = next;
           }
        });

        // 3. tempDivの中から特定のタグを探してクラスを付与/置換する
        // 見出し: タグは変更せずクラスのみ付与
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(tagName => {
          tempDiv.querySelectorAll(tagName).forEach(el => {
            el.classList.add(`m-article__${tagName}`);
          });
        });

        // pタグ: クラスが付与されていない場合のみ m-article__text を付与
        tempDiv.querySelectorAll('p').forEach(el => {
          if (!el.closest('dl, dt, dd') && el.classList.length === 0) {
            el.classList.add('m-article__text');
          }
        });

        // ulタグとその子要素にクラスを追加
        tempDiv.querySelectorAll('ul').forEach(ul => {
          ul.classList.add('m-article__ul');
          ul.querySelectorAll('li').forEach(li => li.classList.add('m-article__ul-item', 'm-article__text'));
        });

        // olタグとその子要素にクラスを追加
        tempDiv.querySelectorAll('ol').forEach(ol => {
          ol.classList.add('m-article__ol');
          ol.querySelectorAll('li').forEach(li => li.classList.add('m-article__ol-item', 'm-article__text'));
        });

        // dlタグ: dt/ddをdiv.m-article__dl-itemでラップしクラスを追加
        tempDiv.querySelectorAll('dl').forEach(dl => {
          dl.classList.add('m-article__dl');
          const children = Array.from(dl.children);
          let wrapper = null;
          children.forEach(child => {
            if (child.tagName === 'DT') {
              wrapper = document.createElement('div');
              wrapper.classList.add('m-article__dl-item');
              dl.insertBefore(wrapper, child);
              wrapper.appendChild(child);
              child.classList.add('m-article__dt');
            } else if (child.tagName === 'DD') {
              if (wrapper) {
                wrapper.appendChild(child);
              }
              child.classList.add('m-article__dd');
            }
          });
        });

        // tableタグ: クラスを追加し、ラッパーで囲む
        tempDiv.querySelectorAll('table').forEach(table => {
          table.classList.add('m-article__table');

          // theadの生成
          const firstRow = table.querySelector('tr');
          if (firstRow) {
            const thead = document.createElement('thead');
            const tbody = table.querySelector('tbody') || table;

            // 最初の行のtdをthに変換
            Array.from(firstRow.children).forEach(cell => {
              const th = document.createElement('th');
              th.innerHTML = cell.innerHTML;
              // 属性があればコピーする処理が必要ならここに追加
              firstRow.replaceChild(th, cell);
            });

            thead.appendChild(firstRow);
            table.insertBefore(thead, tbody);
          }

          const wrapper = document.createElement('div');
          wrapper.className = 'm-article__section m-article__section--table';
          if (table.parentNode && table.parentNode.tagName === 'FIGURE' && table.parentNode.classList.contains('table')) {
            table.parentNode.replaceWith(wrapper);
            wrapper.appendChild(table);
          }
        });

        // 4. クラスが追加された後のHTMLを、最終的なコンテナに挿入
        detailsContainer.innerHTML = tempDiv.innerHTML;
      }
    })
    .catch(error => {
      articleSection.innerHTML = '<p>記事の読み込みに失敗しました。</p>';
    });
}

/**
 * お問い合わせフォームのAPI送信
 */
function handleContactForm() {
  const form = document.getElementById('contact-form');
  if (!form) {
    return;
  }

  // フォーム内の要素を取得
  const privacyPolicyCheckbox = document.getElementById('privacy_policy');
  const submitButton = document.getElementById('submit-button');

  if (privacyPolicyCheckbox && submitButton) {
    privacyPolicyCheckbox.addEventListener('change', function () {
      // チェックされていれば disabled 属性を解除、されていなければ設定
      submitButton.disabled = !this.checked;
      if (this.checked) {
        submitButton.classList.remove('c-button--disabled');
        const btnText = submitButton.querySelector('.c-btn__text');
        if (btnText) btnText.textContent = '送信';
      } else {
        submitButton.classList.add('c-button--disabled');
        const btnText = submitButton.querySelector('.c-btn__text');
        if (btnText) btnText.textContent = '入力が完了していません';
      }
    });
  }

  // フォームが送信されたときの処理
  form.addEventListener('submit', function (event) {
    event.preventDefault(); // ページの再読み込みをキャンセル

    // --- バリデーション処理 ---
    let isValid = true;
    let hasEmptyFields = false; // 未記入項目があるかどうかのフラグ
    const overallError = document.getElementById('overall-error-message');
    // 全てのエラーメッセージを一旦クリア
    document.querySelectorAll('.p-contact-form__error-message').forEach(el => {
      el.textContent = '';
    });
    if (overallError) overallError.textContent = '';

    // チェックする必須項目のリスト [name属性, 日本語名]
    const requiredFields = [
      ['name', '氏名'],
      ['furigana', 'ふりがな'],
      ['company', '会社名'],
      ['email', 'メールアドレス'],
      ['tel', '電話番号'],
      ['subject', '件名'],
      ['inquiry_type', 'お問い合わせ種類'],
      ['body', 'お問い合わせ内容'],
      ['how_did_you_know', '弊社のことをどこでお知りになりましたか'],
    ];
    // 必須項目をループでチェック
    requiredFields.forEach(([fieldName, fieldLabel]) => {
      const input = form.elements[fieldName];
      if (!input.value.trim()) {
        const errorElement = document.querySelector(`.p-contact-form__error-message[data-for="${fieldName}"]`);
        if (errorElement) {
          errorElement.textContent = '※必須項目です。';
        }
        isValid = false;
        hasEmptyFields = true; // 未記入項目があったことを記録
      }
    });
    // メールアドレス（確認）のチェック
    const emailInput = form.elements['email'];
    const emailConfirmInput = form.elements['email_confirm'];
    if (emailInput.value !== emailConfirmInput.value) {
      const errorElement = document.querySelector('.p-contact-form__error-message[data-for="email_confirm"]');
      if (errorElement) {
        errorElement.textContent = '※メールアドレスが一致しません。';
      }
      isValid = false;
    }

    // バリデーションエラーがあれば、ここで処理を中断
    if (!isValid) {
      if (hasEmptyFields && overallError) {
        overallError.textContent = '未記入の箇所があります。';
      } else if (overallError) {
        overallError.textContent = '入力内容に誤りがあります。';
      }
      // バリデーションエラーがあった場合、同意チェックを外してボタンを無効化する
      if (privacyPolicyCheckbox) {
        privacyPolicyCheckbox.checked = false;
      }
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('c-button--disabled');
        const btnText = submitButton.querySelector('.c-btn__text');
        if (btnText) btnText.textContent = '入力が完了していません';
      }
      return;
    }
    // --- バリデーション処理 ここまで ---
    // FormDataを使用してフォームのデータを取得
    const formData = new FormData(form);

    // APIに送信するデータを構築
    // formData.get('name属性') で各フォーム部品の値を取得します。
    const apiData = {
      name: formData.get('name') || '',
      email: formData.get('email') || '',
      ext_01: formData.get('subject') || '', // 件名
      ext_02: formData.get('furigana') || '', // ふりがな
      ext_03: formData.get('company') || '', // 会社名
      ext_04: formData.get('tel') || '', // 電話番号
      ext_05: formData.get('how_did_you_know') || '', // 弊社のことをどこでお知りになりましたか
      body: formData.get('body') || '', // お問い合わせ内容
      inquiry_category_id: 2,
      validate_only: false
    };

    submitButton.disabled = true; // 送信中はボタンを無効化
    const apiUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/8/contact';

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*'
      },
      body: JSON.stringify(apiData)
    })
    .then(response => {
      // 422エラー（バリデーションエラー）の場合もJSONとして処理する
      if (!response.ok && response.status !== 422) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // APIからのバリデーションエラーがある場合
      if (data.errors && data.errors.length > 0) {
        const overallError = document.getElementById('overall-error-message');
        if (overallError) {
          overallError.textContent = '入力内容に誤りがあります。';
        }

        // APIのフィールド名とフォームのname属性をマッピング
        const apiFieldToFormName = {
          'name': 'name',
          'email': 'email',
          'ext_01': 'subject',
          'ext_02': 'furigana',
          'ext_03': 'company',
          'ext_04': 'tel',
          'ext_05': 'how_did_you_know',
          'body': 'body',
        };

        data.errors.forEach(error => {
          const formFieldName = apiFieldToFormName[error.field];
          if (formFieldName) {
            const errorElement = document.querySelector(`.p-contact-form__error-message[data-for="${formFieldName}"]`);
            if (errorElement) {
              errorElement.textContent = `※${error.message}`;
            }
          }
        });

        // 同意チェックを外し、再度ボタンを無効化
        privacyPolicyCheckbox.checked = false;
        submitButton.disabled = true;
        submitButton.classList.add('c-button--disabled');
        const btnText = submitButton.querySelector('.c-btn__text');
        if (btnText) btnText.textContent = '入力が完了していません';
      } else {
        // 成功した場合の処理s
        const formContainer = document.querySelector('.p-contact__body');
        if (formContainer) {
          formContainer.innerHTML = `
            <div class="p-contact-success">
              <h2 class="p-contact-success__title">お問い合わせありがとうございます</h2>
              <p class="p-contact-success__text">
                お問い合わせ内容を送信いたしました。<br>
                担当者より折り返しご連絡いたしますので、今しばらくお待ちください。
              </p>
              <div class="p-contact-success__button-area">
                <a href="/" class="c-button">トップページへ戻る</a>
              </div>
            </div>
          `;
        }
      }
    })
    .catch(error => {
      const overallError = document.getElementById('overall-error-message');
      if (overallError) {
        overallError.textContent = '送信中にエラーが発生しました。時間をおいて再度お試しください。';
      }
      // エラーが発生した場合でも、ユーザーが再試行できるようにボタンを有効化
      submitButton.disabled = !privacyPolicyCheckbox.checked;
    });
  });
}

/**
 * メニュー一覧ページのページネーションHTMLを生成して表示する
 * @param {object} pager - APIから返されるpagerオブジェクト
 * @param {string} currentPage - 現在のページ番号
 */
function renderMenuPagination(pager, currentPage) {
  const container = document.getElementById('pagination-container');
  const totalPages = pager.totalPageCnt || pager.last_page;
  if (!container || !pager || totalPages <= 1) {
    if (container) container.innerHTML = '';
    return;
  }
  const lastPage = totalPages;
  const current = parseInt(currentPage, 10);
  const template = document.getElementById('pagination-template');
  if (!template) return;
  const paginationElement = template.content.cloneNode(true);
  const prevLink = paginationElement.querySelector('.c-pagination__btn-prev');
  const nextLink = paginationElement.querySelector('.c-pagination__btn-next');
  const itemsList = paginationElement.querySelector('.c-pagination__items');
  const itemTemplate = paginationElement.querySelector('.c-pagination__item');

  itemsList.innerHTML = '';
  // 「前へ」のリンク
  if (current > 1) {
    prevLink.href = `/menu/?page=${current - 1}`;
  } else {
    prevLink.remove();
  }
  // ページ番号のリンク
  for (let i = 1; i <= lastPage; i++) {
    const newItem = itemTemplate.cloneNode(true);
    const newLink = newItem.querySelector('.c-pagination__link');
    newLink.href = `/menu/?page=${i}`;
    newLink.textContent = i;
    if (i === current) {
      newItem.classList.add('is-current');
    }
    itemsList.appendChild(newItem);
  }
  // 「次へ」のリンク
  if (current < lastPage) {
    nextLink.href = `/menu/?page=${current + 1}`;
  } else {
    nextLink.remove();
  }
  container.innerHTML = '';
  container.appendChild(paginationElement);
}

/**
 * メニュー一覧ページのデータをAPIから取得して表示する
 */
function handleMenuListPage() {
  const container = document.getElementById('js-menu-list');
  if (!container) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page') || '1';
  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/4/menu-list?cnt=12&pageID=${page}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok && response.status !== 404) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const items = data.list;
      if (!items || items.length === 0) {
        container.innerHTML = '<li>メニューはありません。</li>';
        return;
      }

      const html = items.map(item => {
        const imageUrl = (item.image && item.image.url) || '/assets/img/common/img-empty.jpg';
        const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
        return `
        <li class="m-archive-case__item swiper-slide">
          <a href="/menu/?id=${item.topics_id}" class="m-archive-case__link">
            <div class="m-archive-case__thumbnail">
              <img src="${imageUrl}" alt="${subject}" loading="lazy" class="m-archive-case__img">
            </div>
            <div class="m-archive-case__content">
              <div class="m-archive-case__tags">
                <span class="c-category">${item.contents_type_nm || 'Service'}</span>
              </div>
              <h4 class="m-archive-case__title">${subject}</h4>
              <p class="m-archive-case__company">${item.overview || ''}</p>
            </div>
          </a>
        </li>
      `}).join('');
      container.innerHTML = html;

      // ページネーション生成
      renderMenuPagination(data.pageInfo || data.pager, page);
    })
    .catch(error => {
      console.error('Failed to load menu list:', error);
      container.innerHTML = '<li>メニューの読み込みに失敗しました。</li>';
    });
}

/**
 * 提供メニュー詳細ページのデータをAPIから取得
 */
function handleMenuDetailPage() {
  const container = document.getElementById('menu-detail-container');
  if (!container) {
    return; // 対象コンテナがなければ何もしない
  }

  const urlParams = new URLSearchParams(window.location.search);
  const menuId = urlParams.get('id');

  // URLにidがなければ何もしない
  if (!menuId) {
    return;
  }

  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/4/menu-details/${menuId}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const details = data.details;
      if (!details) {
        container.innerHTML = '<p>提供メニューが見つかりませんでした。</p>';
        return;
      }

      // タイトルの改行タグ処理
      const subject = details.subject ? details.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '<br>') : '';

      // ページタイトルを動的に更新
      document.title = subject.replace(/<br\s*\/?>/gi, '') + ' | イグニション・ポイント フォース株式会社';

      // パンくずリストのHTMLを生成
      const breadcrumbs = [
        { name: 'HOME', href: '/' },
        { name: '提供メニュー', href: '/menu/' },
        { name: subject.replace(/<br\s*\/?>/gi, ''), href: '' } // 現在のページ
      ];
      let breadcrumbHtml = '<div class="c-breadcrumb"><div class="l-container l-container--fluid"><ol class="c-breadcrumb__list">';
      breadcrumbs.forEach(crumb => {
        breadcrumbHtml += `<li class="c-breadcrumb__item">${crumb.href ? `<a href="${crumb.href}">${crumb.name}</a>` : `<span>${crumb.name}</span>`}</li>`;
      });
      breadcrumbHtml += '</ol></div></div>';

      // パンくずリストをコンテナに挿入
      const menuDetailBreadcrumb = document.getElementById('menu-detail-breadcrumb');
      if (menuDetailBreadcrumb) {
        menuDetailBreadcrumb.innerHTML = breadcrumbHtml;
        menuDetailBreadcrumb.style.display = 'block';
      }

      // 詳細ページでは一覧用のヘッダーを非表示にする
      const menuListHeader = document.getElementById('menu-list-header');
      if (menuListHeader) menuListHeader.style.display = 'none';

      // value_conceptのリストを生成
      let valueConceptHtml = '';
      if (details.value_concept_title && details.value_concept_body) {
        details.value_concept_title.forEach((title, index) => {
          const body = details.value_concept_body[index] || '';
          const number = String(index + 1).padStart(2, '0');
          valueConceptHtml += `
            <div class="p-menu-detail__offering-item">
              <div class="p-menu-detail__offering-item-header">
                <span class="p-menu-detail__offering-item-number">${number}</span>
                <h5 class="p-menu-detail__offering-item-title">${title}</h5>
              </div>
              <p class="p-menu-detail__offering-item-text">${body}</p>
            </div>
          `;
        });
      }

      // パネルレイアウトの判定
      const layoutKey = details.panel_layout && details.panel_layout.key ? details.panel_layout.key : details.panel_layout;
      const panelLayoutClass = layoutKey === 'line'
        ? 'p-menu-detail__offering p-menu-detail__offering--column'
        : 'p-menu-detail__offering';

      const menuHtml = `
        <div class="p-menu-detail__header">
          <div class="p-menu-detail__title-area">
            <div class="l-container l-container--fluid">
              <div class="p-menu-detail__title-main">
                <h1 class="p-menu-detail__title">${subject}</h1>
                <p class="p-menu-detail__subtitle">${details.group_nm || ''} / Service Offering</p>
              </div>
              <div class="p-menu-detail__title-lead">
                <div class="p-menu-detail__title-lead-content">
                  <h2 class="p-menu-detail__title-lead-title">${details.sub_subject || ''}</h2>
                  <p class="p-menu-detail__title-lead-text">${details.overview || ''}</p>
                </div>
                ${details.image && details.image.url ? `
                <div class="p-menu-detail__title-lead-image">
                  <img src="${details.image.url}" alt="${details.image.desc || ''}">
                </div>` : ''}
              </div>
              <div class="p-menu-detail__title-border"></div>
            </div>
          </div>
        </div>

        <div class="l-container l-container--fluid">
          <div class="l-sidebar">
            <aside class="l-sidebar__nav">
              <hgroup class="l-sidebar__nav-hgroup">
                <h2 class="l-sidebar__nav-title">SERVICE</h2>
                <p class="l-sidebar__nav-title-jp">サービス</p>
              </hgroup>
              <nav>
                <ul class="l-sidebar__nav-list">
                  <li><a href="#latest-trends">最新動向</a></li>
                  <li><a href="#industry-challenges">業界課題</a></li>
                  <li><a href="#main-offering">主要オファリング</a></li>
                </ul>
              </nav>
            </aside>
            <section class="l-sidebar__content">
              <section id="latest-trends" class="p-menu-detail__section">
                <hgroup class="p-menu-detail__section-hgroup">
                  <p class="p-menu-detail__section-subtitle">Latest Trends</p>
                  <h3 class="p-menu-detail__section-title">最新動向</h3>
                </hgroup>
                <div class="p-menu-detail__section-body">
                  <p class="c-section-text">${details.latest_trends_body || ''}</p>
                </div>
              </section>
              ${details.latest_trends_image && details.latest_trends_image.url ? `
              <div class="p-menu-detail__image">
                <img src="${details.latest_trends_image.url}" alt="${details.latest_trends_image.desc || ''}">
              </div>` : ''}

              <section id="industry-challenges" class="p-menu-detail__section">
                <hgroup class="p-menu-detail__section-hgroup">
                  <p class="p-menu-detail__section-subtitle">Industry Challenges</p>
                  <h3 class="p-menu-detail__section-title">業界課題</h3>
                </hgroup>
                <div class="p-menu-detail__section-body">
                  <p class="c-section-text">${(details.industry_challenges_body || '').replace(/\r\n/g, '<br>')}</p>
                </div>
              </section>

              <section id="main-offering" class="p-menu-detail__section">
                <hgroup class="p-menu-detail__section-hgroup">
                  <p class="p-menu-detail__section-subtitle">Challenges</p>
                  <h3 class="p-menu-detail__section-title">主要オファリング</h3>
                </hgroup>
                <div class="p-menu-detail__section-body">
                  <p class="c-section-text">${details.challenges_body || ''}</p>
                </div>
              </section>

              <section class="${panelLayoutClass}">
                <h4 class="p-menu-detail__offering-title">提供価値のイメージ</h4>
                <div class="p-menu-detail__offering-list">${valueConceptHtml}</div>
              </section>
            </section>
          </div>
        </div>

        <section class="p-menu-detail__related-cases" id="related-cases-section">
          <!-- ここに関連事例が動的に挿入されます -->
        </section>

        <section class="p-menu-detail__related-menu">
          <div class="l-container l-container--fluid">
            <h2 class="c-section-title">その他提供メニュー</h2>
            <div class="p-menu-detail__related-menu-list"></div>
          </div>
        </section>
      `;
      container.innerHTML = menuHtml;

      // HTML生成後にサイドバーのスクロール連動を再初期化
      initSidebarScrollSpy();

      // 関連事例APIのURLを構築
      const relatedCasesApiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/5/case_relation?ext_14=${menuId}`;

      // 関連事例APIを叩いてHTMLを生成
      fetch(relatedCasesApiUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Related cases API request failed with status: ${response.status}`);
          }
          return response.json();
        })
        .then(relatedData => {
          const allCases = relatedData.list;
          if (!allCases || allCases.length === 0) {
            return;
          }

          // service_offering.module_id が現在の menuId と一致する事例のみをフィルタリング
          const cases = allCases.filter(caseItem =>
            caseItem.service_offering && caseItem.service_offering.module_id == menuId
          );

          // フィルタリングした結果、表示する事例がない場合は何もしない
          if (cases.length === 0) {
            return;
          }

          // 事例が1件以上ある場合のみセクションを生成
          const relatedCasesSection = document.getElementById('related-cases-section');
          relatedCasesSection.innerHTML = `
            <div class="l-container l-container--fluid">
              <div class="p-menu-detail__related-cases-header">
                <h2 class="c-section-title">本サービスの事例</h2>
                <div class="m-archive-case-nav">
                  <button class="m-archive-case-nav__prev m-archive-case-nav__prev--menu" type="button" aria-label="前のスライドへ"></button>
                  <button class="m-archive-case-nav__next m-archive-case-nav__next--menu" type="button" aria-label="次のスライドへ"></button>
                </div>
              </div>
              <div class="p-menu-detail__related-cases-container">
                <div class="m-archive-case m-archive-case--menu swiper">
                  <ul class="m-archive-case__list swiper-wrapper">
                    <!-- ここに関連事例がAPIから挿入されます -->
                  </ul>
                </div>
              </div>
              <div class="p-menu-detail__related-cases-button">
                <a href="/case_study/" class="c-button c-button--black">
                  <span class="c-btn__text">一覧を見る</span>
                  <span class="c-button__icon"><img src="/assets/img/common/icon-button-arrow.svg" alt=""></span>
                </a>
              </div>
            </div>
          `;

          const listElement = relatedCasesSection.querySelector('.swiper-wrapper');
          if (!listElement) return;

          const casesHtml = cases.map(caseItem => {
            const tagsHtml = (caseItem.ext_4 || []).map(tag => `<span class="c-category">${tag.label}</span>`).join('');
            const subject = caseItem.subject ? caseItem.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
            return `
              <li class="m-archive-case__item swiper-slide">
                <div class="m-archive-case__link">
                  <a href="/case_study/?id=${caseItem.topics_id}" class="m-archive-case__link-cover"></a>
                  <div class="m-archive-case__thumbnail">
                    <img src="${(caseItem.top_image && caseItem.top_image.url) || '/assets/img/common/img-empty.jpg'}" alt="" loading="lazy" class="m-archive-case__img">
                  </div>
                  <div class="m-archive-case__content">
                    <div class="m-archive-case__tags">${tagsHtml}</div>
                    <h4 class="m-archive-case__title">${subject}</h4>
                    <p class="m-archive-case__company">${caseItem.client || ''}</p>
                  </div>
                </div>
              </li>
            `;
          }).join('');

          listElement.innerHTML = casesHtml;

          // HTMLが挿入された後にSwiperを初期化
          const swiperElement = relatedCasesSection.querySelector('.swiper');
          if (swiperElement) {
            initArchiveCaseSwiper(swiperElement);
          }
        })
        .catch(error => {
          console.error('Failed to load related cases:', error);
        });

      // その他の提供メニューを取得
      const otherMenusApiUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/4/menu-list';
      fetch(otherMenusApiUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Other menus API request failed with status: ${response.status}`);
          }
          return response.json();
        })
        .then(menuData => {
          const otherMenusList = menuData.list
            .filter(item => item.topics_id != menuId) // 現在のメニューを除外
            .slice(0, 3); // 最大3件に絞る

          const otherMenusContainer = container.querySelector('.p-menu-detail__related-menu-list');
          if (otherMenusContainer && otherMenusList.length > 0) {
            const otherMenusHtml = otherMenusList.map(item => {
              const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
              return `
              <a href="/menu/?id=${item.topics_id}" class="p-menu-detail__related-menu-item">
                <div class="p-menu-detail__related-menu-item-image">
                    <img src="${(item.image && item.image.url) || 'https://placehold.jp/420x200.png'}" alt="" class="p-menu-detail__related-menu-item-img">
                </div>
                <div class="p-menu-detail__related-menu-item-content">
                    <h3 class="p-menu-detail__related-menu-item-title">${subject}</h3>
                </div>
              </a>
            `}).join('');
            otherMenusContainer.innerHTML = otherMenusHtml;
          }
        })
        .catch(error => {
          console.error('Failed to load other menus:', error);
        });
    })
    .catch(error => {
      console.error('Failed to load menu detail:', error);
      container.innerHTML = '<p>メニューの読み込みに失敗しました。</p>';
    });
}

/**
 * 事例一覧ページのページネーションHTMLを生成して表示する
 * @param {object} pager - APIから返されるpagerオブジェクト
 * @param {string} currentPage - 現在のページ番号
 */
function renderCasePagination(pager, currentPage) {
  const container = document.getElementById('pagination-container');
  const totalPages = pager.totalPageCnt || pager.last_page;
  if (!container || !pager || totalPages <= 1) {
    if (container) container.innerHTML = '';
    return;
  }
  const lastPage = totalPages;
  const current = parseInt(currentPage, 10);
  const template = document.getElementById('pagination-template');
  if (!template) return;
  const paginationElement = template.content.cloneNode(true);
  const prevLink = paginationElement.querySelector('.c-pagination__btn-prev');
  const nextLink = paginationElement.querySelector('.c-pagination__btn-next');
  const itemsList = paginationElement.querySelector('.c-pagination__items');
  const itemTemplate = paginationElement.querySelector('.c-pagination__item');

  itemsList.innerHTML = '';
  // 「前へ」のリンク
  if (current > 1) {
    prevLink.href = `/case_study/?page=${current - 1}`;
  } else {
    prevLink.remove();
  }
  // ページ番号のリンク
  for (let i = 1; i <= lastPage; i++) {
    const newItem = itemTemplate.cloneNode(true);
    const newLink = newItem.querySelector('.c-pagination__link');
    newLink.href = `/case_study/?page=${i}`;
    newLink.textContent = i;
    if (i === current) {
      newItem.classList.add('is-current');
    }
    itemsList.appendChild(newItem);
  }
  // 「次へ」のリンク
  if (current < lastPage) {
    nextLink.href = `/case_study/?page=${current + 1}`;
  } else {
    nextLink.remove();
  }
  container.innerHTML = '';
  container.appendChild(paginationElement);
}

/**
 * 事例一覧ページのデータをAPIから取得して表示する
 */
function handleCaseListPage() {

  const caseListContainer = document.getElementById('js-case-study-list');

  // 事例一覧ページであるかを確認
  if (!caseListContainer) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page') || '1';

  const baseUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/5/case_relation';
  const apiUrl = `${baseUrl}?cnt=12&pageID=${page}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        if (response.status !== 404) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      }
      return response.json();
    })
    .then(data => {
      // APIレスポンスが空、またはlistプロパティが存在しない場合のガード処理
      if (!data || !data.list || data.list.length === 0) {
        caseListContainer.innerHTML = '<p>現在、公開中の事例はありません。</p>';
        return;
      }

      const caseItems = data.list.map(item => {
        // カテゴリタグのHTMLを生成
        let tagsHtml = '';
        if (item.industry) {
          tagsHtml += `<span class="c-category">${item.industry}</span>`;
        }
        // サムネイル画像のURLを取得（存在しない場合はデフォルト画像）
        const thumbnailUrl = item.top_image && item.top_image.url
          ? item.top_image.url
          : '/assets/img/common/no-image.png'; // デフォルト画像のパスを指定してください
        const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';

        return `
          <li class="m-archive-case__item">
            <div class="m-archive-case__link">
              <a href="/case_study/?id=${item.topics_id}" class="m-archive-case__link-cover"></a>
              <div class="m-archive-case__thumbnail">
                <img src="${thumbnailUrl}" alt="" loading="lazy" class="m-archive-case__img">
              </div>
              <div class="m-archive-case__content">
                <div class="m-archive-case__tags">${tagsHtml}</div>
                <h4 class="m-archive-case__title">${subject}</h4>
                <p class="m-archive-case__company">${item.sub_subject ? item.sub_subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : ''}</p>
              </div>
            </div>
          </li>
        `;
      }).join('');

      caseListContainer.innerHTML = caseItems;

      // ページネーションを生成
      renderCasePagination(data.pageInfo || data.pager, page);
    })
    .catch(error => {
      console.error('Error fetching case studies:', error);
      caseListContainer.innerHTML = '<p>事例の読み込みに失敗しました。時間をおいて再度お試しください。</p>';
    });
}

/**
 * 事例詳細ページのデータをAPIから取得して表示する
 */
function handleCaseDetailPage() {
  const container = document.getElementById('case-study-detail-container');
  if (!container) return;

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  if (!id) return;

  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/5/case-details/${id}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const details = data.details;
      if (!details) {
        container.innerHTML = '<p>事例が見つかりませんでした。</p>';
        return;
      }

      // 各種データの整形
      const subject = details.subject ? details.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '<br>') : '';

      // ページタイトルを動的に更新
      document.title = subject.replace(/<br\s*\/?>/gi, '') + ' | イグニション・ポイント フォース株式会社';

      const subSubject = details.sub_subject ? details.sub_subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '<br>') : '';
      const topImage = (details.top_image && details.top_image.url) || 'https://placehold.jp/1440x810.png';
      const insertImage = (details.insert_image && details.insert_image.url) || null;
      const tagsHtml = (details.ext_4 || []).map(tag => `<span class="c-category">${tag.label}</span>`).join('');

      // マイルストーンの固定リスト定義とアクティブ判定
      const milestoneSteps = [
        { label: '現状調査・<br>DXアセスメント', match: ['現状調査・ DXアセスメント', '現状調査・DXアセスメント'] },
        { label: 'DX戦略策定', match: ['DX戦略策定'] },
        { label: '要件定義', match: ['要件定義'] },
        { label: 'システム設計', match: ['システム設計'] },
        { label: 'システム開発', match: ['システム開発'] },
        { label: '技術検証・テスト', match: ['技術検証・テスト'] },
        { label: '運用保守', match: ['運用保守'] }
      ];
      const apiMilestoneLabels = (details.milestone || []).map(item => item.label);
      const milestoneHtml = milestoneSteps.map(step => {
        const isActive = apiMilestoneLabels.some(label => step.match.includes(label));
        return `<li class="p-case-study-detail__milestone-item ${isActive ? 'is-active' : ''}">${step.label}</li>`;
      }).join('');

      const bottomImageHtml = (details.bottom_image || []).map(img => `<div class="p-case-study-detail__image"><div class="l-container l-container--fluid"><img src="${img.url}" alt="${img.desc || ''}"></div></div>`).join('');
      const keywords = (details.ext_4 || []).map(item => item.label).join(' / ');

      // パンくずリストを動的に生成
      const breadcrumbContainer = document.getElementById('case-study-detail-breadcrumb');
      if (breadcrumbContainer) {
        const breadcrumbs = [
          { name: 'HOME', href: '/' },
          { name: 'プロジェクト事例', href: '/case_study/' },
          { name: subject.replace(/<br\s*\/?>/gi, ''), href: '' }
        ];
        let breadcrumbHtml = '<div class="c-breadcrumb"><div class="l-container l-container--fluid"><ol class="c-breadcrumb__list">';
        breadcrumbs.forEach(crumb => {
          breadcrumbHtml += `<li class="c-breadcrumb__item">${crumb.href ? `<a href="${crumb.href}">${crumb.name}</a>` : `<span>${crumb.name}</span>`}</li>`;
        });
        breadcrumbHtml += '</ol></div></div>';
        breadcrumbContainer.innerHTML = breadcrumbHtml;
      }

      const html = `
        <div class="p-case-study-detail">
          <div class="p-case-study-detail__header">
            <div class="l-container l-container--fluid">
              <div class="p-case-study-detail__header-inner">
                <div class="p-case-study-detail__title-area">
                  <div class="p-case-study-detail__title-main">
                    <h1 class="p-case-study-detail__title">${subject}</h1>
                    <p class="p-case-study-detail__subtitle">事例 / Case Study</p>
                  </div>
                </div>
                <div class="p-case-study-detail__key-visual">
                  <img src="${topImage}" alt="">
                </div>
              </div>
            </div>
          </div>

          <div class="l-container l-container--fluid">
            <div class="l-sidebar">
              <aside class="l-sidebar__nav">
                <hgroup class="l-sidebar__nav-hgroup">
                  <h2 class="l-sidebar__nav-title">Case Study</h2>
                  <p class="l-sidebar__nav-title-jp">サービス</p>
                </hgroup>
                <nav>
                  <ul class="l-sidebar__nav-list">
                    <li><a href="#challenges">顧客課題</a></li>
                    <li><a href="#solution">ソリューション</a></li>
                    <li><a href="#approach">アプローチ</a></li>
                    <li><a href="#why-igpf">Why IGPF</a></li>
                    <li><a href="#project-impact">プロジェクトインパクト</a></li>
                  </ul>
                </nav>
              </aside>
              <section class="l-sidebar__content">
                <div class="p-case-study-detail__client-info">
                  <dl>
                    <div class="p-case-study-detail__client-info-row">
                      <dt>クライアント</dt>
                      <dd>${details.client || ''}</dd>
                    </div>
                    <div class="p-case-study-detail__client-info-row">
                      <dt>業界</dt>
                      <dd>${details.industry || ''}</dd>
                    </div>
                    <div class="p-case-study-detail__client-info-row">
                      <dt>キーワード</dt>
                      <dd>${keywords}</dd>
                    </div>
                  </dl>
                </div>

                <h2 class="p-case-study-detail__content-title">${subSubject}</h2>

                <section id="challenges" class="p-case-study-detail__section">
                  <hgroup class="p-case-study-detail__section-hgroup">
                    <p class="p-case-study-detail__section-subtitle">Challenges</p>
                    <h3 class="p-case-study-detail__section-title">顧客課題</h3>
                  </hgroup>
                  <div class="p-case-study-detail__section-body">
                    <p class="c-section-text">${details.challenges || ''}</p>
                  </div>
                </section>

                <section id="solution" class="p-case-study-detail__section">
                  <hgroup class="p-case-study-detail__section-hgroup">
                    <p class="p-case-study-detail__section-subtitle">Solution</p>
                    <h3 class="p-case-study-detail__section-title">ソリューション</h3>
                  </hgroup>
                  <div class="p-case-study-detail__section-body">
                    <p class="c-section-text">${details.solution || ''}</p>
                  </div>
                </section>

                <section id="approach" class="p-case-study-detail__section">
                  <hgroup class="p-case-study-detail__section-hgroup">
                    <p class="p-case-study-detail__section-subtitle">Approach</p>
                    <h3 class="p-case-study-detail__section-title">アプローチ</h3>
                  </hgroup>
                  <div class="p-case-study-detail__section-body">
                    <p class="c-section-text">${details.approach || ''}</p>
                    <div class="p-case-study-detail__milestones">
                      <ul class="p-case-study-detail__milestone-list">
                        ${milestoneHtml}
                      </ul>
                    </div>
                  </div>
                </section>

                ${insertImage ? `<div class="p-case-study-detail__image">
                  <img src="${insertImage}" alt="">
                </div>` : ''}

                <section id="why-igpf" class="p-case-study-detail__section">
                  <hgroup class="p-case-study-detail__section-hgroup">
                    <p class="p-case-study-detail__section-subtitle">Value Proposition</p>
                    <h3 class="p-case-study-detail__section-title">Why IGPF</h3>
                  </hgroup>
                  <div class="p-case-study-detail__section-body">
                    <p class="c-section-text">${details.value_proposition || ''}</p>
                  </div>
                </section>

                <section id="project-impact" class="p-case-study-detail__section">
                  <hgroup class="p-case-study-detail__section-hgroup">
                    <p class="p-case-study-detail__section-subtitle">Project Impact</p>
                    <h3 class="p-case-study-detail__section-title">プロジェクトインパクト</h3>
                  </hgroup>
                  <div class="p-case-study-detail__section-body">
                    <p class="c-section-text">${details.project_impact || ''}</p>
                  </div>
                </section>

                ${(details.side_images && details.side_images.length > 0) ? (
                  details.side_images.length === 1 ?
                  `<div class="p-case-study-detail__image">
                    <img src="${details.side_images[0].url}" alt="${details.side_images[0].desc || ''}">
                  </div>` :
                  `<div class="p-case-study-detail__image-grid">
                    ${details.side_images.map(img => `<div class="p-case-study-detail__image-grid-image"><img src="${img.url}" alt="${img.desc || ''}"></div>`).join('')}
                  </div>`
                ) : ''}
              </section>
            </div>
          </div>

          ${bottomImageHtml}

          <section class="p-case-study-detail__related-cases">
            <h2 class="c-section-title">その他の事例</h2>
            <div class="m-archive-case m-archive-case--related">
              <ul class="m-archive-case__list" id="js-related-cases-list">
                <!-- 関連事例は別途JSで取得 -->
              </ul>
            </div>
          </section>
        </div>
      `;
      container.innerHTML = html;

      // HTML生成後にサイドバーのスクロール連動を再初期化
      initSidebarScrollSpy();

      // 関連事例の取得と表示
      const relatedCasesContainer = document.getElementById('js-related-cases-list');
      if (relatedCasesContainer) {
        // 現在の事例を除外する必要があるため、3件より多く(4件)取得
        const relatedApiUrl = 'https://ignitionpoint-force.g.kuroco.app/rcms-api/5/case_relation?cnt=4';
        fetch(relatedApiUrl)
          .then(res => res.json())
          .then(relatedData => {
            if (!relatedData || !relatedData.list) return;

            const relatedItems = relatedData.list
              .filter(item => item.topics_id != id) // 現在表示中の事例を除外
              .slice(0, 3); // 最新3件に絞る

            if (relatedItems.length > 0) {
              const relatedHtml = relatedItems.map(item => {
                const categoryName = item.industry || '';
                const tagsHtml = categoryName ? `<span class="c-category">${categoryName}</span>` : '';
                const thumbnailUrl = (item.top_image && item.top_image.url) || '/assets/img/common/no-image.png';
                const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
                const companyName = item.industry || '';

                return `
                  <li class="m-archive-case__item swiper-slide">
                    <a href="/case_study/?id=${item.topics_id}" class="m-archive-case__link">
                      <div class="m-archive-case__thumbnail">
                        <img src="${thumbnailUrl}" alt="${subject}" loading="lazy" class="m-archive-case__img">
                      </div>
                      <div class="m-archive-case__content">
                        <div class="m-archive-case__tags">${tagsHtml}</div>
                        <h4 class="m-archive-case__title">${subject}</h4>
                        <p class="m-archive-case__company">${companyName}</p>
                      </div>
                    </a>
                  </li>
                `;
              }).join('');
              relatedCasesContainer.innerHTML = relatedHtml;
            }
          })
          .catch(error => {
            console.error('Failed to load related case studies:', error);
            if (relatedCasesContainer) relatedCasesContainer.innerHTML = '<li>関連事例の読み込みに失敗しました。</li>';
          });
      }
    })
    .catch(error => {
      console.error('Failed to load case study detail:', error);
      container.innerHTML = '<p>事例の読み込みに失敗しました。</p>';
    });
}

/**
 * インタビュー一覧ページのページネーションHTMLを生成して表示する
 * @param {object} pager - APIから返されるpagerオブジェクト
 * @param {string} currentPage - 現在のページ番号
 */
function renderInterviewPagination(pager, currentPage) {
  const container = document.getElementById('pagination-container');
  const totalPages = pager.totalPageCnt || pager.last_page;
  if (!container || !pager || totalPages <= 1) {
    if (container) container.innerHTML = '';
    return;
  }
  const lastPage = totalPages;
  const current = parseInt(currentPage, 10);
  const template = document.getElementById('pagination-template');
  if (!template) return;
  const paginationElement = template.content.cloneNode(true);
  const prevLink = paginationElement.querySelector('.c-pagination__btn-prev');
  const nextLink = paginationElement.querySelector('.c-pagination__btn-next');
  const itemsList = paginationElement.querySelector('.c-pagination__items');
  const itemTemplate = paginationElement.querySelector('.c-pagination__item');

  itemsList.innerHTML = '';
  // 「前へ」のリンク
  if (current > 1) {
    prevLink.href = `/recruit/interview/?page=${current - 1}`;
  } else {
    prevLink.remove();
  }
  // ページ番号のリンク
  for (let i = 1; i <= lastPage; i++) {
    const newItem = itemTemplate.cloneNode(true);
    const newLink = newItem.querySelector('.c-pagination__link');
    newLink.href = `/recruit/interview/?page=${i}`;
    newLink.textContent = i;
    if (i === current) {
      newItem.classList.add('is-current');
    }
    itemsList.appendChild(newItem);
  }
  // 「次へ」のリンク
  if (current < lastPage) {
    nextLink.href = `/recruit/interview/?page=${current + 1}`;
  } else {
    nextLink.remove();
  }
  container.innerHTML = '';
  container.appendChild(paginationElement);
}

/**
 * インタビュー一覧ページのデータをAPIから取得して表示する
 */
function handleInterviewListPage() {
  const container = document.getElementById('js-interview-archive-list');
  if (!container) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page') || '1';
  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/7/interview-list?cnt=12&pageID=${page}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok && response.status !== 404) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const items = data.list;
      if (!items || items.length === 0) {
        container.innerHTML = '<li>インタビューはありません。</li>';
        return;
      }

      const html = items.map(item => {
        const imageUrl = item.detail_top_image.url;
        // タグ: contents_type_nm を先頭に、続けて tag 配列を展開
        let tagsHtml = '';
        if (item.contents_type_nm) {
          tagsHtml += `<span class="m-archive__tag">#${item.contents_type_nm}</span>`;
        }
        if (item.tag && Array.isArray(item.tag)) {
          tagsHtml += item.tag.map(tag => `<span class="m-archive__tag">${tag}</span>`).join('');
        }
        // タイトル: <br> や <br> などの改行タグを削除して1行にする
        const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';

        return `
        <li class="m-archive__item">
          <a href="/recruit/interview/?id=${item.topics_id}" class="m-archive__link">
            <div class="m-archive__thumbnail">
              <img src="${imageUrl}" alt="${item.name || subject}" loading="lazy" class="m-archive__img">
            </div>
            <div class="m-archive__content">
              <div class="m-archive__tags">${tagsHtml}</div>
              <h3 class="m-archive__title">${subject}</h3>
              <p class="m-archive__name">${item.name || ''}</p>
              <p class="m-archive__text">${item.list_summary || ''}</p>
            </div>
          </a>
        </li>
      `}).join('');
      container.innerHTML = html;

      // ページネーション生成
      renderInterviewPagination(data.pageInfo || data.pager, page);
    })
    .catch(error => {
      console.error('Failed to load interview list:', error);
      container.innerHTML = '<li>インタビューの読み込みに失敗しました。</li>';
    });
}

/**
 * インタビュー詳細ページのデータをAPIから取得して表示する
 */
function handleInterviewDetailPage() {
  const container = document.getElementById('interview-detail-container');
  if (!container) return;

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  if (!id) return;

  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/7/interview-details/${id}`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const details = data.details;
      if (!details) {
        container.innerHTML = '<p>記事が見つかりませんでした。</p>';
        return;
      }

      // ページタイトルを動的に更新
      document.title = (details.name || '') + ' | 社員インタビュー | イグニション・ポイント フォース株式会社';

      // タイトルの改行タグ処理
      const subject = details.subject ? details.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '<br>') : '';
      // タグ生成
      let tagsHtml = '';
      if (details.contents_type_nm) {
        tagsHtml += `<span class="p-interview-detail__header-tag">#${details.contents_type_nm}</span>`;
      }
      if (details.tag && Array.isArray(details.tag)) {
        tagsHtml += details.tag.map(tag => `<span class="p-interview-detail__header-tag">${tag}</span>`).join('');
      }

      // 画像
      const mainImage = details.detail_top_image.url;
      const reasonImage = (details.reason_image && details.reason_image.url) || null;
      const satisfactionImage = (details.satisfaction_image && details.satisfaction_image.url) || null;
      const messageImage = (details.message_image && details.message_image.url) || null;
      const bottomImage = (details.bottom_image && details.bottom_image.url) || null;

      const html = `
        <div class="p-interview-detail">
          <div class="p-interview-detail__header">
            <div class="l-container l-container--fluid">
              <div class="c-breadcrumb">
                <ol class="c-breadcrumb__list">
                  <li class="c-breadcrumb__item"><a href="/">HOME</a></li>
                  <li class="c-breadcrumb__item"><a href="/recruit/">採用情報</a></li>
                  <li class="c-breadcrumb__item"><a href="/recruit/interview/">社員インタビュー</a></li>
                  <li class="c-breadcrumb__item"><span>${details.subject ? details.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : ''}</span></li>
                </ol>
              </div>
              <div class="p-interview-detail__header-content">
                <div class="p-interview-detail__header-info">
                  <p class="p-interview-detail__header-subtitle">INTERVIEW</p>
                  <h1 class="p-interview-detail__header-title">${subject}</h1>
                  <div class="p-interview-detail__header-tags">${tagsHtml}</div>
                </div>
                <figure class="p-interview-detail__header-image">
                  <img src="${mainImage}" alt="">
                </figure>
              </div>
            </div>
          </div>

          <div class="p-interview-detail__profile-area">
            <div class="l-container l-container--fluid">
              <div class="p-interview-detail__profile">
                <div class="p-interview-detail__profile-info">
                  <p class="p-interview-detail__profile-role">${details.affiliation || ''}</p>
                  <p class="p-interview-detail__profile-name">${details.name || ''}</p>
                </div>
                <div class="p-interview-detail__profile-text">${details.overview || ''}</div>
              </div>
            </div>
          </div>

          <div class="p-interview-detail__body">
            <div class="p-interview-detail__nav">
              <div class="l-container l-container--fluid">
                <ul class="p-interview-detail__nav-list">
                  <li class="p-interview-detail__nav-item">
                    <a href="#section-reason" class="p-interview-detail__nav-link">
                      <span class="p-interview-detail__nav-text">入社した理由</span>
                      <span class="p-interview-detail__nav-meta">
                        <span class="p-interview-detail__nav-message">REASON</span>
                        <span class="p-interview-detail__nav-arrow">
                          <img src="/assets/img/recruit/icon-arrow.svg" alt="">
                        </span>
                      </span>
                    </a>
                  </li>
                  <li class="p-interview-detail__nav-item">
                    <a href="#section-satisfaction" class="p-interview-detail__nav-link">
                      <span class="p-interview-detail__nav-text">仕事のやりがい</span>
                      <span class="p-interview-detail__nav-meta">
                        <span class="p-interview-detail__nav-message">SATISFACTION</span>
                        <span class="p-interview-detail__nav-arrow">
                          <img src="/assets/img/recruit/icon-arrow.svg" alt="">
                        </span>
                      </span>
                    </a>
                  </li>
                  <li class="p-interview-detail__nav-item">
                    <a href="#section-message" class="p-interview-detail__nav-link">
                      <span class="p-interview-detail__nav-text">候補者へのメッセージ</span>
                      <span class="p-interview-detail__nav-meta">
                        <span class="p-interview-detail__nav-message">MESSAGE</span>
                        <span class="p-interview-detail__nav-arrow">
                          <img src="/assets/img/recruit/icon-arrow.svg" alt="">
                        </span>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="p-interview-detail__content">
              <section id="section-reason" class="p-interview-detail__section">
                <div class="p-interview-detail__section-inner">
                  ${reasonImage ? `<figure class="p-interview-detail__section-image">
                    <img src="${reasonImage}" alt="入社した理由">
                  </figure>` : ''}
                  <div class="p-interview-detail__section-body">
                    <div class="p-interview-detail__section-content">
                      <div class="c-heading c-heading--02">
                        <p class="c-heading__subtitle">入社した理由</p>
                        <h2 class="c-heading__text">${details.reason_title || ''}</h2>
                        <span class="c-heading__line"></span>
                      </div>
                      <div class="p-interview-detail__section-text">${details.reason_body ? details.reason_body.replace(/\r\n/g, '<br>') : ''}</div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="section-satisfaction" class="p-interview-detail__section p-interview-detail__section--reverse">
                <div class="p-interview-detail__section-inner">
                  ${satisfactionImage ? `<figure class="p-interview-detail__section-image">
                    <img src="${satisfactionImage}" alt="仕事のやりがい">
                  </figure>` : ''}
                  <div class="p-interview-detail__section-body">
                    <div class="p-interview-detail__section-content">
                      <div class="c-heading c-heading--02">
                        <p class="c-heading__subtitle">仕事のやりがい</p>
                        <h2 class="c-heading__text">${details.satisfaction_title || ''}</h2>
                        <span class="c-heading__line"></span>
                      </div>
                      <div class="p-interview-detail__section-text">${details.satisfaction_body ? details.satisfaction_body.replace(/\r\n/g, '<br>') : ''}</div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="section-message" class="p-interview-detail__section">
                <div class="p-interview-detail__section-inner">
                  ${messageImage ? `<figure class="p-interview-detail__section-image">
                    <img src="${messageImage}" alt="候補者へのメッセージ">
                  </figure>` : ''}
                  <div class="p-interview-detail__section-body">
                    <div class="p-interview-detail__section-content">
                      <div class="c-heading c-heading--02">
                        <p class="c-heading__subtitle">候補者へのメッセージ</p>
                        <h2 class="c-heading__text">${details.message_title || ''}</h2>
                        <span class="c-heading__line"></span>
                      </div>
                      <div class="p-interview-detail__section-text">${details.message_body ? details.message_body.replace(/\r\n/g, '<br>') : ''}</div>
                    </div>
                  </div>
                </div>
              </section>

              ${bottomImage ? `<div class="p-interview-detail__bottom-image">
                 <img src="${bottomImage}" alt="">
              </div>` : ''}
            </div>
          </div>

          <section class="p-interview-detail__related">
            <div class="l-container l-container--fluid">
              <h2 class="p-interview-detail__related-title"><span>#${details.contents_type_nm || ''}</span> に関連するインタビュー</h2>
              <div class="m-archive m-archive--interview">
                <ul class="m-archive__list" id="js-related-interview-list">
                  <!-- JSで挿入 -->
                </ul>
              </div>
            </div>
          </section>
        </div>
      `;
      container.innerHTML = html;

      // 関連インタビューの取得と表示
      const relatedContainer = document.getElementById('js-related-interview-list');
      if (relatedContainer && details.contents_type) {
        const relatedApiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/7/interview-list?cnt=50`;

        fetch(relatedApiUrl)
          .then(res => res.json())
          .then(relatedData => {
            const list = relatedData.list || [];
            // 自分自身を除外 かつ 同じカテゴリ(contents_type)の記事を抽出して先頭3件を取得
            const filteredList = list.filter(item =>
              item.topics_id !== details.topics_id &&
              item.contents_type === details.contents_type
            ).slice(0, 3);

            if (filteredList.length === 0) {
              const relatedSection = document.querySelector('.p-interview-detail__related');
              if (relatedSection) relatedSection.style.display = 'none';
              return;
            }

            const relatedHtml = filteredList.map(item => {
              const imageUrl = item.detail_top_image.url;
              let tagsHtml = '';
              if (item.contents_type_nm) {
                tagsHtml += `<span class="m-archive__tag">#${item.contents_type_nm}</span>`;
              }
              if (item.tag && Array.isArray(item.tag)) {
                tagsHtml += item.tag.map(tag => `<span class="m-archive__tag">${tag}</span>`).join('');
              }
              const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';

              return `
                <li class="m-archive__item">
                  <a href="/recruit/interview/?id=${item.topics_id}" class="m-archive__link">
                    <div class="m-archive__thumbnail">
                      <img src="${imageUrl}" alt="${item.name || subject}" loading="lazy" class="m-archive__img">
                    </div>
                    <div class="m-archive__content">
                      <div class="m-archive__tags">${tagsHtml}</div>
                      <h3 class="m-archive__title">${subject}</h3>
                      <p class="m-archive__name">${item.name || ''}</p>
                      <p class="m-archive__text">${item.list_summary || ''}</p>
                    </div>
                  </a>
                </li>
              `;
            }).join('');
            relatedContainer.innerHTML = relatedHtml;
          })
          .catch(err => {
            console.error('Failed to load related interviews:', err);
            const relatedSection = document.querySelector('.p-interview-detail__related');
            if (relatedSection) relatedSection.style.display = 'none';
          });
      }
    })
    .catch(error => {
      console.error('Failed to load interview detail:', error);
      container.innerHTML = '<p>インタビューの読み込みに失敗しました。</p>';
    });
}

/**
 * ビジネス（サービス）ページの関連事例をAPIから取得して表示する
 */
function handleBusinessCaseList() {
  const targets = [
    {
      id: 'js-business-integration-case-list',
      category: 'システムインテグレーション',
      categoryId: 25,
      swiperContainerSelector: '.p-business-integration__case-container .swiper',
      navPrevSelector: '.m-archive-case-nav__prev',
      navNextSelector: '.m-archive-case-nav__next'
    },
    {
      id: 'js-business-consulting-case-list',
      category: 'テクノロジーコンサルティング',
      categoryId: 30,
      swiperContainerSelector: '#case .swiper',
      navPrevSelector: '.m-archive-case-nav__prev',
      navNextSelector: '.m-archive-case-nav__next'
    }
  ];

  // 現在のページに該当するターゲットを探す
  const target = targets.find(t => document.getElementById(t.id));
  if (!target) return;

  const container = document.getElementById(target.id);
  // カテゴリIDで絞り込んで10件取得
  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/5/case_relation?cnt=10&contents_type[]=${target.categoryId}&order=ymd_desc`;

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const list = data.list || [];
      // APIで絞り込まれているのでそのまま使う
      const filteredList = list;

      if (filteredList.length === 0) {
        const section = container.closest('section');
        if (section) {
          section.style.display = 'none';
        }
        return;
      }

      const html = filteredList.map(item => {
        const tagsHtml = item.industry ? `<span class="c-category">${item.industry}</span>` : '';
        const thumbnailUrl = (item.top_image && item.top_image.url) || '/assets/img/common/no-image.png';
        const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';

        return `
          <li class="m-archive-case__item swiper-slide">
            <div class="m-archive-case__link">
              <a href="/case_study/?id=${item.topics_id}" class="m-archive-case__link-cover"></a>
              <div class="m-archive-case__thumbnail">
                <img src="${thumbnailUrl}" alt="" loading="lazy" class="m-archive-case__img">
              </div>
              <div class="m-archive-case__content">
                <div class="m-archive-case__tags">${tagsHtml}</div>
                <h4 class="m-archive-case__title">${subject}</h4>
                <p class="m-archive-case__company">${item.ext_col_03 || ''}</p>
              </div>
            </div>
          </li>
        `;
      }).join('');

      container.innerHTML = html;

      // Swiper初期化
      const swiperElement = document.querySelector(target.swiperContainerSelector);
      if (swiperElement) {
        initArchiveCaseSwiper(swiperElement);
      }
    })
    .catch(error => {
      console.error('Failed to load business case list:', error);
      container.innerHTML = '<li class="swiper-slide">事例の読み込みに失敗しました。</li>';
    });
}

/**
 * ビジネス（サービス）ページの提供メニューをAPIから取得して表示する
 */
function handleBusinessMenuList() {
  const targets = [
    {
      id: 'js-business-integration-menu-list',
      contentType: 26,
      classPrefix: 'p-business-integration'
    },
    {
      id: 'js-business-consulting-menu-list',
      contentType: 29,
      classPrefix: 'p-business-consulting'
    }
  ];

  // 現在のページに該当するターゲットを探す
  const target = targets.find(t => document.getElementById(t.id));
  if (!target) return;

  const container = document.getElementById(target.id);
  const apiUrl = `https://ignitionpoint-force.g.kuroco.app/rcms-api/4/menu-list?contents_type[]=${target.contentType}`;

  fetch(apiUrl)
    .then(response => response.json())
    .then(data => {
      const list = data.list || [];
      if (list.length === 0) {
        const section = container.closest('section');
        if (section) section.style.display = 'none';
        return;
      }

      const html = list.map(item => {
        const subject = item.subject ? item.subject.replace(/(<|&lt;)br\s*\/?(>|&gt;)/gi, '') : '';
        const imageUrl = (item.image && item.image.url) || 'https://placehold.jp/960x220.png';

        return `
          <li class="${target.classPrefix}__menu-item">
            <a href="/menu/?id=${item.topics_id}" class="${target.classPrefix}__menu-link">
              <span class="${target.classPrefix}__menu-text">${subject}</span>
              <span class="${target.classPrefix}__menu-bg">
                <img src="${imageUrl}" alt="${subject}" loading="lazy">
              </span>
            </a>
          </li>
        `;
      }).join('');

      container.innerHTML = html;
    })
    .catch(error => {
      console.error('Failed to load business menu list:', error);
    });
}

// DOMが読み込まれたら各処理を実行
document.addEventListener('DOMContentLoaded', () => {
  // ページごとに必要な初期化処理を呼び出す
  if (document.getElementById('threejs-container')) {
    initThreeJSBackground();
  }

  // ニュースページの処理
  const newsListHeader = document.getElementById('news-list-header');
  const newsListWrapper = document.getElementById('news-list-wrapper');
  const articleSection = document.getElementById('article-section');

  // ニュース関連の要素がある場合のみ、ニュースページのロジックを実行
  if (newsListHeader || newsListWrapper || articleSection) {
    const urlParams = new URLSearchParams(window.location.search);
    const articleId = urlParams.get('id');

    if (articleId) {
      // 詳細ページを表示
      if (newsListHeader) newsListHeader.style.display = 'none';
      if (newsListWrapper) newsListWrapper.style.display = 'none';
      if (articleSection) articleSection.style.display = 'block';
      handleNewsDetailPage();
    } else {
      // 一覧ページを表示
      if (articleSection) articleSection.style.display = 'none';
      handleNewsListPage();
    }
  }

  // /menu/ ページの処理
  const menuListHeader = document.getElementById('menu-list-header');
  const menuListWrapper = document.getElementById('menu-list-wrapper');
  const menuDetailContainer = document.getElementById('menu-detail-container');

  if (menuListWrapper || menuDetailContainer) {
    const urlParams = new URLSearchParams(window.location.search);
    const menuId = urlParams.get('id');

    if (menuId) {
      if (menuListHeader) menuListHeader.style.display = 'none';
      if (menuListWrapper) menuListWrapper.style.display = 'none';
      if (menuDetailContainer) menuDetailContainer.style.display = 'block';
      handleMenuDetailPage();
    } else {
      if (menuDetailContainer) menuDetailContainer.style.display = 'none';
      handleMenuListPage(); // メニュー一覧ページの表示処理を呼び出し
    }
  }

  // /recruit/interview/ ページの処理
  const interviewListHeader = document.getElementById('interview-list-header');
  const interviewListWrapper = document.getElementById('interview-list-wrapper');
  const interviewDetailContainer = document.getElementById('interview-detail-container');

  if (interviewListWrapper || interviewDetailContainer) {
    const urlParams = new URLSearchParams(window.location.search);
    const interviewId = urlParams.get('id');

    if (interviewId) {
      if (interviewListHeader) interviewListHeader.style.display = 'none';
      if (interviewListWrapper) interviewListWrapper.style.display = 'none';
      if (interviewDetailContainer) interviewDetailContainer.style.display = 'block';
      handleInterviewDetailPage();
    } else {
      if (interviewDetailContainer) interviewDetailContainer.style.display = 'none';
      handleInterviewListPage(); // インタビュー一覧ページの表示処理を呼び出し
    }
  }

  // /case_study/ ページの処理
  const caseListHeader = document.getElementById('case-study-list-header');
  const caseListWrapper = document.getElementById('case-study-list-wrapper');
  const caseDetailContainer = document.getElementById('case-study-detail-container');

  if (caseListHeader || caseListWrapper || caseDetailContainer) {
    const urlParams = new URLSearchParams(window.location.search);
    const caseId = urlParams.get('id');

    if (caseId) {
      if (caseListHeader) caseListHeader.style.display = 'none';
      if (caseListWrapper) caseListWrapper.style.display = 'none';
      if (caseDetailContainer) caseDetailContainer.style.display = 'block';
      handleCaseDetailPage();
    } else {
      if (caseDetailContainer) caseDetailContainer.style.display = 'none';
      handleCaseListPage();
    }
  }

  handleContactForm();
  handleTopPageNews(); // トップページのニュース表示処理を呼び出し
  handleTopPageInterview();
  handleBusinessCaseList(); // ビジネス（サービス）ページの関連事例表示処理を呼び出し
  handleBusinessMenuList(); // ビジネス（サービス）ページの提供メニュー表示処理を呼び出し
});
